module.exports = __webpack_public_path__ + "static/onyia-d78aea61eba495ae24fb0dbd2d8e2e30.jpg";